<template>
    <div class="compliance-page">
        <BasePageTitle :title="tokens.fullScreenComplianceDocuments.title"/>
        <p class="desc title__small">{{tokens.fullScreenComplianceDocuments.desc}}</p>
        <BasePanel class="panel">
            <template #content>
                <div class="inner">
                    <div class="item" v-for="(item, key) in documents" :key="key">
                        <div class="item__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9 12.5H10V10.5H11C11.2833 10.5 11.5208 10.4042 11.7125 10.2125C11.9042 10.0208 12 9.78333 12 9.5V8.5C12 8.21667 11.9042 7.97917 11.7125 7.7875C11.5208 7.59583 11.2833 7.5 11 7.5H9V12.5ZM10 9.5V8.5H11V9.5H10ZM13 12.5H15C15.2833 12.5 15.5208 12.4042 15.7125 12.2125C15.9042 12.0208 16 11.7833 16 11.5V8.5C16 8.21667 15.9042 7.97917 15.7125 7.7875C15.5208 7.59583 15.2833 7.5 15 7.5H13V12.5ZM14 11.5V8.5H15V11.5H14ZM17 12.5H18V10.5H19V9.5H18V8.5H19V7.5H17V12.5ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z" fill="var(--System-OnSurfaceVariant)"/>
                            </svg>
                        </div>
                        <div class="item__content label__large">
                            <div class="item__title">{{ item.title }}</div>
                            <div class="item__desc">{{ item.desc }}</div>
                        </div>
                        <BaseButtonSmall 
                            :button-text="tokens.fullScreenComplianceDocuments.button"
                            :button-style="'tonal-secondary'"
                            @click.native="openPDF(item.href)"
                        />
                    </div>
                </div>
            </template>
        </BasePanel>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {BRAND, COMPLIANCE_DOCUMENTS} from '@/common/config'
import BasePageTitle from "@/new-design/shared/ui/titles/BasePageTitle.vue"
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import BaseButtonSmall from '@/new-design/shared/ui/buttons/BaseButtonSmall'

export default {
    name: "ComplianceDocumentsPage",
    components: { BasePanel, BaseButtonSmall, BasePageTitle },
    data() {
        return {
            brand: BRAND,
            complianceDocuments: COMPLIANCE_DOCUMENTS,
        }
    },
    computed: {
        ...mapGetters(['tokens', 'customTokens', 'staticBase']),
        documents() {
            let path = (this.staticBase ? this.staticBase.replace("image","brands") : "") + this.brand;

            if (this.complianceDocuments && Array.isArray(this.complianceDocuments)){
                let result = [];

                this.complianceDocuments.forEach((item, idx) => {
                    result.push({
                        title: this.customTokens.fullScreenComplianceDocuments.documentsTitle?.[this.brand]?.[idx] || '',
                        desc: this.customTokens.fullScreenComplianceDocuments.documentsDesc?.[this.brand]?.[idx] || '',
                        href: `${path}/CompilanceDocuments/${item}`
                    })
                })

                return result;
            }

            return [];
        }
    },
    methods: {
        openPDF(href){
            window.open(href, '_blank')
        }
    }
}
</script>

<style scoped>
.panel {
    border: none !important;
    padding: 0;
}

.compliance-page { }

.inner {
    padding: 32px 0px;
    color: var(--System-OnSurfaceVariant, #9A9DAB);
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.desc {
    color: var(--System-OnSurfaceVariant);
    font-weight: 500;
    padding-bottom: 12px;
}

.item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant, #3F454F);
    padding: 8px 12px;
    gap: 16px;
}

.item__icon { }

.item__content { 
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 2px 0;
}
.item__title { 
    color: var(--System-OnSurface);
}
.item__desc { 
    color: var(--System-Outline);
}

</style>
